import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import * as recordLabels from '@webapp/sdk/record-labels';
import { Actions } from '../../actions';
import {
  CreateRecordLabel,
  CreateRecordLabelSuccess,
  CreateRecordLabelError,
} from '../action-creators';
import { CREATE_RECORD_LABEL } from '../actions';

export const createRecordLabelsEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, CreateRecordLabel>(CREATE_RECORD_LABEL),
    mergeMap(async (action) => {
      try {
        const recordLabel = await recordLabels.create(
          action.rosterName,
          action.merchOwnership,
          action.recordingOwnership
        );

        return new CreateRecordLabelSuccess({
          ...recordLabel,
          artistCount: action.artists.length,
        }, action.artists, action.rosterName);
      } catch (err) {
        return new CreateRecordLabelError(err.message);
      }
    })
  );
